export default __webpack_public_path__ + "static/media/manThink.a830e97d.png";